import styled from 'styled-components';
export var SvgWrapper = /*#__PURE__*/styled.svg.attrs({
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink'
}).withConfig({
  displayName: "svg-wrapper__SvgWrapper",
  componentId: "sc-1tfnlk1-0"
})([""]);